<template>
  <generic-modal :modal-key="'post_game'" :has-extra-modal-class="addOnGameData.success ? 'postgame_modal' : 'postgame_modal lost'"
                 @close="$emit('close')">
    <template slot="content">
      <div v-if="addOnGameData.success">
        <img src="static/images/game_popups/face_won.png" class="face_img">
        <h1>{{ getTranslations.post_game_add_on_success }}<br> {{ getTranslations.post_game_add_on_congrats }}</h1>
        <span v-if="addOnMode.assignPointsAfterAddOnGame">
        <h2>{{ getTranslations.post_game_pay_out }}</h2>
        <h3>{{ addOnGameData.payOutPoints }} {{ getTranslations.post_game_points }}</h3>
        </span>
        <button type="button" class="new_game_btn" @click.prevent="$emit('playNewGame')">{{ getTranslations.post_game_new_game }}</button>
        <button type="" class="invite_friends_btn" v-if="facebookFunctionality">
          <img src="static/images/home/logo-facebook.svg">
          <p>{{ getTranslations.post_game_fb_share }}</p>
        </button>
        <p v-if="facebookFunctionality">{{ getTranslations.post_game_fb_share_points }}</p>
      </div>
      <div v-else>
        <img src="static/images/game_popups/face_lost.png" class="face_img">
        <h1>{{ getTranslations.post_game_add_on_fail_no }}<br> {{ getTranslations.post_game_add_on_fail_almost }}</h1>
        <span v-if="addOnMode.lostPointsForMissedAddOnGame">
        <h2>{{ getTranslations.post_game_add_on_fail_lost }}</h2>
        <h3>{{ addOnGameData.riskPoints }} {{ getTranslations.post_game_points }}</h3>
        <p>{{ getTranslations.post_game_add_on_fail_new_game }}</p>
        </span>
        <button type="button" class="new_game_btn" @click.prevent="$emit('playNewGame')">{{ getTranslations.post_game_new_game }}</button>
      </div>
    </template>
  </generic-modal>
</template>

<script>
/* eslint no-console: "off" */
/* postgame_lost_no_points_lost.html --> NO_WIN_LOSE */
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'result-of-add-on-game',
  components: { GenericModal },
  created() {
    console.log('in Result of Add on Game created hook');
    if (!this.addOnGameData.gameId) this.$router.push('/home');
    const payload = { gameId: this.addOnGameData.gameId, successful: this.addOnGameData.success, correctAnswers: this.addOnGameData.correctAnswers };
    this.updateDGamesForAddOn(payload);
  },
  beforeDestroy() {
    this.resetAddOnGameData();
  },
  methods: {
    ...mapActions('profile', [
      'updateDGamesForAddOn',
    ]),
    ...mapMutations('game', [
      'resetAddOnGameData',
    ]),
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'addOnGameData',
    ]),
    ...mapState('common', [
      'facebookFunctionality',
      'addOnMode',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addongame/ResultOfAddOnGame.vue